/**
 * Allergies and dislikes API. GET lists + customer selected IDs; POST to save selections.
 */
import { apiGet, apiPost } from '../../../shared/api/client';
import { endpoints } from '../../../shared/config/endpoints';
import type { Allergy, Dislike } from '../profile/types';

export interface AllergiesResponse {
  allergies?: Allergy[];
  customer_selected_allergy_ids?: number[];
  data?: {
    allergies?: Allergy[];
    customer_selected_allergy_ids?: number[];
    categories?: unknown[];
    customer_selected_allergies?: number[];
  };
  categories?: unknown[];
}

export interface DislikesResponse {
  dislikes?: Dislike[];
  customer_selected_dislike_ids?: number[];
  data?: {
    dislikes?: Dislike[];
    customer_selected_dislike_ids?: number[];
    categories?: unknown[];
    customer_selected_dislikes?: number[];
  };
  categories?: unknown[];
}

export async function fetchAllergies(customer_id: number): Promise<AllergiesResponse> {
  const endpoint = endpoints.allergies;
  const params = { customer_id };
  const res = await apiGet<AllergiesResponse>(endpoint, params);
  return res ?? {};
}

export async function fetchDislikes(customer_id: number): Promise<DislikesResponse> {
  const endpoint = endpoints.dislikes;
  const params = { customer_id };
  const res = await apiGet<DislikesResponse>(endpoint, params);
  return res ?? {};
}

export async function saveAllergies(customer_id: number, allergy_ids: number[]): Promise<{ success?: boolean }> {
  const endpoint = endpoints.allergies;
  const payload = { customer_id, allergy_ids };
  const res = await apiPost<{ success?: boolean }>(endpoint, payload);
  return res ?? { success: true };
}

export async function saveDislikes(customer_id: number, dislike_ids: number[]): Promise<{ success?: boolean }> {
  const endpoint = endpoints.dislikes;
  const payload = { customer_id, dislike_ids };
  const res = await apiPost<{ success?: boolean }>(endpoint, payload);
  return res ?? { success: true };
}
